import SubscriptionCSP from "../models/csp/SubscriptionCSP";
import productsService from "../services/csp/productsService";

export default {
  methods: {
    async getEstimatedCost(customerId) {
      let totalCost =
        this.getCustomerBillingSummaryCSP(customerId).totalCost || 0;
      if (this.getNonAzurePlanSubscriptionsCSP(customerId) != 0) {
        for (const sub of this.getNonAzurePlanSubscriptionsCSP(customerId)) {
          const unitPrice = await this.licenceUnitPrice(sub);
          totalCost += unitPrice * sub.quantity;
        }
      }
      return totalCost;
    },
    async licenceUnitPrice(sub: SubscriptionCSP): Promise<number> {
      const billingInfo = this.getLicencesBillingCSPBySubscriptionId(sub.id);
      if (billingInfo) {
        const ERPPrice = await this.licenceMonthlyERPPrice(sub);
        if (Number.isFinite(ERPPrice)) {
          return ERPPrice;
        } else {
          return billingInfo.unitPrice;
        }
      } else {
        return 0;
      }
    },
    async licenceMonthlyERPPrice(sub: SubscriptionCSP): Promise<number> {
      const productData = {
        productId: sub.productId,
        skuId: sub.skuId,
        billingCycle: sub.billingCycle,
        termDuration: sub.termDuration
      };
      const ERPPrice = await productsService.methods.getProductPrice(
        productData
      );
      if (productData.termDuration == "P1Y") {
        return ERPPrice / 12;
      } else if (productData.termDuration == "P3Y") {
        return ERPPrice / 36;
      } else return ERPPrice;
    }
  }
};
